import styled from '@emotion/styled'
import { css, TextField } from '@mui/material'
import { defaultTheme } from '../../theme/default.theme'

export const UInput = styled(TextField)(
    () => css`
        color: ${defaultTheme.palette.primary.main};

        &.MuiFormControl-root {
            border-radius: 6px;
            background-color: ${defaultTheme.palette.background.default};
            border: 1px solid ${defaultTheme.palette.background2.main}!important;

            & .MuiInputBase-input {
                font-family: ${defaultTheme.typography.body1.fontFamily};
                font-size: ${defaultTheme.typography.body3.fontSize};
                line-height: ${defaultTheme.typography.body1.lineHeight};
                color: ${defaultTheme.palette.primary.main};
            }

            &:hover {
                border-color: ${defaultTheme.palette.stroke2.main};
            }

            &:focus {
                outline: none;
                box-shadow: none;
            }
        }

        & .MuiInputBase-root {
            border-radius: 6px;
            background-color: ${defaultTheme.palette.background.default}!important;
            &::after {
                content: '';
                border-bottom: 0px !important;
            }
            &::before {
                content: '';
                border-bottom: 0px !important;
            }
            &.Mui-focused {
                border-bottom: 0px;
                border-color: ${defaultTheme.palette.stroke1.main}!important;
                outline: none;
            }
        }

        .MuiInputLabel-root {
            font-size: ${defaultTheme.typography.body2.fontSize};
            color: ${defaultTheme.palette.primary.main};
            &.MuiInputLabel-shrink {
                color: ${defaultTheme.palette.muted.light};
            }
        }

        & .MuiOutlinedInput-notchedOutline {
            border: none;
        }
    `
)
